import {createBrowserRouter} from 'react-router'
import {ResetByEmailPage} from '@freckle/classroom/ts/common/components/page/reset-by-email'
import {NotFound} from './../../../pages/not-found'
import {AuthRedirectRoute} from './auth-redirect-route'
import {routerV2Common} from './common'
import {DefaultPage} from './default-page'
import {routerV2Ela} from './ela'
import {
  ChangePasswordPageHandler,
  DeletedLoginHandler,
  ErrorRootBoundary,
  LoginPageHandler,
  SignUpPageHandler,
  SsoMismatchedSchoolHandler,
  EmailConfirmed,
  InvalidLink,
} from './lazy'
import {routerV2Math} from './math'
import {routerV2Redirects} from './redirects'
import {routerV2Roster} from './roster'
import {routerV2Science} from './science'
import {ScrollToTop} from './scroll-to-top'
import {routerV2SocialStudies} from './social-studies'
import {UseLanguage} from './use-language'

const routes = [
  {
    path: '/',
    element: <DefaultPage />,
  },
  {
    path: '/sso-mismatched-school',
    element: <SsoMismatchedSchoolHandler />,
  },
  {
    path: '/signup',
    element: <AuthRedirectRoute component={SignUpPageHandler} />,
  },
  {
    path: '/login',
    element: <AuthRedirectRoute component={LoginPageHandler} />,
  },
  {
    path: '/reset-password',
    element: <AuthRedirectRoute component={ChangePasswordPageHandler} />,
  },
  {
    path: '/static/reset-password.html',
    element: <AuthRedirectRoute component={ChangePasswordPageHandler} />,
  },
  {
    path: '/static/email-confirmed.html',
    element: <EmailConfirmed />,
  },
  {
    path: '/static/link-invalid.html',
    element: <InvalidLink />,
  },
  {
    path: '/deleted-login',
    element: <DeletedLoginHandler />,
  },
  {
    path: '/reset-by-email',
    element: <ResetByEmailPage />,
  },
  ...routerV2Common,
  ...routerV2Redirects,
  ...routerV2Ela,
  ...routerV2Math,
  ...routerV2Science,
  ...routerV2SocialStudies,
  ...routerV2Roster,
  {
    path: '*',
    element: <NotFound />,
  },
].map(({path, element}) => ({
  path,
  element: (
    <ScrollToTop>
      <>
        <UseLanguage />
        {element}
      </>
    </ScrollToTop>
  ),
  errorElement: <ErrorRootBoundary />,
}))

export const routerV2 = createBrowserRouter(routes)
